let portalRef

export const getPortal = () => {
  if (window.getPortalRef) return window.getPortalRef()
  return portalRef || null
}

export const setPortal = ref => {
  if (!ref || portalRef === ref) {
    return false
  }

  portalRef = ref
  return true
}
